import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { ModalHeader } from "./styles_vanilla.css";

export type SyncErrorModalProps = {
  showSyncErrorModal: boolean;
  closeSyncErrorModal: () => void;
  label: string;
  modalMessage: string;
  errorMessages: string[] | undefined | null;
  mappingUrl: string;
};

export const SyncErrorModal = ({
  showSyncErrorModal,
  closeSyncErrorModal,
  label,
  modalMessage,
  errorMessages,
  mappingUrl,
}: SyncErrorModalProps) => {
  const buttonLabel = label === "Mapping error" ? "Go to mapping" : "Okay, got it";
  const onButtonClick = () => {
    if (label === "Mapping error") {
      window.location.replace(mappingUrl);
    } else {
      closeSyncErrorModal();
    }
  };
  return (
    <ModalV2
      show={showSyncErrorModal}
      onHide={closeSyncErrorModal}
      isCentered={true}
      size="small"
      data-testid="sync-error-modal"
      closeOnClickOutside={true}
      backdrop={true}
      title="Sync Error"
      visuallyHideTitle
      headerClassName={ModalHeader}
    >
      <ModalV2.Body>
        <Flex alignItems="center" justifyContent="center" gap={10} flexDirection={"column"}>
          <Icon
            type="exclamation-circle"
            color={Colors.Danger600}
            size="xxx-large"
            variant="solid"
          />
          <Text align="center" variant="h3">
            {label}
          </Text>
          <Text align="center" css={{ marginTop: "25px" }} variant="secondary-md">
            {modalMessage}
          </Text>
          {!!errorMessages && (
            <Flex flexDirection={"column"} gap={10}>
              {errorMessages.map((msg, idx) => (
                <Text key={idx} align="center" variant="secondary-md">
                  - {msg}
                </Text>
              ))}
            </Flex>
          )}
        </Flex>
        <Flex flexDirection={"column"} gap={10} alignItems="center" css={{ marginTop: "25px" }}>
          <Button onClick={onButtonClick}>{buttonLabel}</Button>
        </Flex>
      </ModalV2.Body>
    </ModalV2>
  );
};
